export enum ButtonEnums   {
    LEFT='LEFT',
    RIGHT='RIGHT',
    PRIMARY="primary",
    SMALL="small",
    MODAL="modal",
    STEPPER="stepper",
    ICON="icon",
    CUSTOM="custom"
} 



